import { AppSettings } from '../constants/constants';
import { Injectable } from '@angular/core';
import { HttpErrorResponse } from '@angular/common/http';
import { Http, Headers } from '@angular/http';
import { Observable, throwError } from 'rxjs'
import { catchError, map, share } from 'rxjs/operators';
import { HttpClient } from 'selenium-webdriver/http';
import { DeviceDetectorService } from 'ngx-device-detector';


@Injectable(
   {
      providedIn: 'root'
   }
)
export class DhukanDataService {
   deviceInfo = null;
   ipAddress: any;

   constructor(private http: Http, private deviceService: DeviceDetectorService) {
      this.deviceInfo = this.deviceService.getDeviceInfo();
      this.fnGetIpAddress();
   }

   fnpostInputParams(url, params) {
      const headers = new Headers({
         //'Content-Type': "application/JSON",
         'token': (localStorage.bstoken === undefined) ? '' : JSON.parse(localStorage.bstoken)
      });


      return this.http.post(AppSettings.base_url + url, params, { headers: headers });
   }

   //Restaurant 
   fnInsertRestaurant(params) {

      return this.fnpostInputParams(AppSettings.insertRestaurantUrl, params);
   }

   fnSetRestaurant(params) {

      return this.fnpostInputParams(AppSettings.setRestaurantUrl, params);
   }


   getRestaurant(params) {

      return this.fnpostInputParams(AppSettings.getRestaurantUrl, params);
   }


   fnDeleteRestaurant(params) {

      return this.fnpostInputParams(AppSettings.deleteRestaurantUrl, params);
   }

   fnCheckRestaurant(params) {

      return this.fnpostInputParams(AppSettings.checkRestaurantUrl, params);
   }





   //Category 
   fnInsertCategory(params) {

      return this.fnpostInputParams(AppSettings.insertCategoryUrl, params);
   }

   fnSetCategory(params) {

      return this.fnpostInputParams(AppSettings.setCategoryUrl, params);
   }


   getCategory(params) {

      return this.fnpostInputParams(AppSettings.getCategoryUrl, params);
   }


   fnDeleteCategory(params) {

      return this.fnpostInputParams(AppSettings.deleteCategoryUrl, params);
   }

   fnCheckCategory(params) {

      return this.fnpostInputParams(AppSettings.checkCategoryUrl, params);
   }

   //Subcategory 
   fnInsertSubcategory(params) {

      return this.fnpostInputParams(AppSettings.insertSubcategoryUrl, params);
   }

   fnSetSubcategory(params) {

      return this.fnpostInputParams(AppSettings.setSubcategoryUrl, params);
   }


   getSubcategory(params) {

      return this.fnpostInputParams(AppSettings.getSubcategoryUrl, params);
   }


   fnDeleteSubcategory(params) {

      return this.fnpostInputParams(AppSettings.deleteSubcategoryUrl, params);
   }

   fnCheckSubcategory(params) {

      return this.fnpostInputParams(AppSettings.checkSubcategoryUrl, params);
   }


   //User 
   fnInsertUser(params) {

      return this.fnpostInputParams(AppSettings.insertUserUrl, params);
   }

   fnSetUser(params) {

      return this.fnpostInputParams(AppSettings.setUserUrl, params);
   }

   fnSetUserPassword(params) {

      return this.fnpostInputParams(AppSettings.setUserPasswordUrl, params);
   }


   getUser(params) {

      return this.fnpostInputParams(AppSettings.getUserUrl, params);
   }


   fnDeleteUser(params) {

      return this.fnpostInputParams(AppSettings.deleteUserUrl, params);
   }

   fnCheckUser(params) {

      return this.fnpostInputParams(AppSettings.checkUserUrl, params);
   }

   getUserlogin(params) {

      return this.fnpostInputParams(AppSettings.getLoginUserUrl, params);
   }

   getLoginSecuritykey(params) {

      return this.fnpostInputParams(AppSettings.getLoginSecuritykeyUrl, params);
   }

   getUserBranch(params) {

      return this.fnpostInputParams(AppSettings.getUserBranchUrl, params);
   }




   //Product 
   fnInsertProduct(params) {

      return this.fnpostInputParams(AppSettings.insertProductUrl, params);
   }

   fnSetProduct(params) {

      return this.fnpostInputParams(AppSettings.setProductUrl, params);
   }


   getProduct(params) {

      return this.fnpostInputParams(AppSettings.getProductUrl, params);
   }

   getProductListview(params) {

      return this.fnpostInputParams(AppSettings.getProductListviewUrl, params);
   }

   getProductReceipe(params) {

      return this.fnpostInputParams(AppSettings.getProductReceipeUrl, params);
   }
   

   fnDeleteProduct(params) {
      return this.fnpostInputParams(AppSettings.deleteProductUrl, params);
   }
   getProductPrice(params) {

      return this.fnpostInputParams(AppSettings.getProductPriceUrl, params);
   }
   fnSetProductPrice(params) {

      return this.fnpostInputParams(AppSettings.setProductPriceUrl, params);
   }



   fnCheckProduct(params) {

      return this.fnpostInputParams(AppSettings.checkProductUrl, params);
   }

   fnGetProductAutoCode(params) {

      return this.fnpostInputParams(AppSettings.getProductAutoCodeUrl, params);
   }




   fnInsertProductVariation(params) {

      return this.fnpostInputParams(AppSettings.insertProductVariationsUrl, params);
   }

   fnSetProductVariation(params) {

      return this.fnpostInputParams(AppSettings.setProductVariationsUrl, params);
   }

   fnDeleteProductVariation(params) {

      return this.fnpostInputParams(AppSettings.deleteProductVariationsUrl, params);
   }
   fnCheckProductVariations(params) {

      return this.fnpostInputParams(AppSettings.checkProductVariationsUrl, params);
   }


   ////ExcelImportEmp
   fnInsertProductImport(params) {

      return this.fnpostInputParams(AppSettings.insertProductImportUrl, params);
   }





   // Userrole
   fnInsertUserrole(params) {

      return this.fnpostInputParams(AppSettings.insertUserroleUrl, params);
   }

   fnSetUserrole(params) {

      return this.fnpostInputParams(AppSettings.setUserroleUrl, params);
   }


   getUserrole(params) {

      return this.fnpostInputParams(AppSettings.getUserroleUrl, params);
   }


   fnDeleteUserrole(params) {

      return this.fnpostInputParams(AppSettings.deleteUserroleUrl, params);
   }

   fnCheckUserrole(params) {

      return this.fnpostInputParams(AppSettings.checkUserroleUrl, params);
   }

   getUserRoleRights(params) {

      return this.fnpostInputParams(AppSettings.getUserRoleRightsUrl, params);
   }

   //Question 
   fnInsertQuestion(params) {

      return this.fnpostInputParams(AppSettings.insertQuestionUrl, params);
   }

   fnSetQuestion(params) {

      return this.fnpostInputParams(AppSettings.setQuestionUrl, params);
   }


   getQuestion(params) {

      return this.fnpostInputParams(AppSettings.getQuestionUrl, params);
   }


   fnDeleteQuestion(params) {

      return this.fnpostInputParams(AppSettings.deleteQuestionUrl, params);
   }

   fnCheckQuestion(params) {

      return this.fnpostInputParams(AppSettings.checkQuestionUrl, params);
   }

   //Answertype
   getAnswertype(params) {

      return this.fnpostInputParams(AppSettings.getAnswertypeUrl, params);
   }

   //Feedback
   getFeedbackListview(params) {

      return this.fnpostInputParams(AppSettings.getFeedbackListviewUrl, params);
   }
   getFeedback(params) {

      return this.fnpostInputParams(AppSettings.getFeedbackUrl, params);
   }


   //Branch 
   fnInsertBranch(params) {

      return this.fnpostInputParams(AppSettings.insertBranchUrl, params);
   }

   fnSetBranch(params) {

      return this.fnpostInputParams(AppSettings.setBranchUrl, params);
   }


   getBranch(params) {

      return this.fnpostInputParams(AppSettings.getBranchUrl, params);
   }


   fnDeleteBranch(params) {

      return this.fnpostInputParams(AppSettings.deleteBranchUrl, params);
   }

   fnCheckBranch(params) {

      return this.fnpostInputParams(AppSettings.checkBranchUrl, params);
   }
   //Country
   getCountries() {
      const headers = new Headers({
         'Content-Type': "application/JSON",
         'X-CSCAPI-KEY': "cmZXSktRU2h5QWpYa1JnZVhYSldmUmhFc1pDZEZ2WDV5ZzVYMkQzRA=="
         // 'token': (localStorage.rbookadtoken === undefined) ? '' : JSON.parse(localStorage.rbookadtoken)                
      });


      return this.http.get("https://api.countrystatecity.in/v1/countries", { headers: headers });

   }
   getState(country) {
      const headers = new Headers({
         'Content-Type': "application/JSON",
         'X-CSCAPI-KEY': "cmZXSktRU2h5QWpYa1JnZVhYSldmUmhFc1pDZEZ2WDV5ZzVYMkQzRA=="
         // 'token': (localStorage.rbookadtoken === undefined) ? '' : JSON.parse(localStorage.rbookadtoken)                
      });


      return this.http.get("https://api.countrystatecity.in/v1/countries/" + country + "/states", { headers: headers });

   }
   //Settings
   fnSetReceiptSettings(params) {

      return this.fnpostInputParams(AppSettings.setReceiptSettingsUrl, params);
   }


   getReceiptSettings(params) {

      return this.fnpostInputParams(AppSettings.getReceiptSettingsUrl, params);
   }




   //Brand 
   fnInsertBrand(params) {

      return this.fnpostInputParams(AppSettings.insertBrandUrl, params);
   }

   fnSetBrand(params) {

      return this.fnpostInputParams(AppSettings.setBrandUrl, params);
   }


   getBrand(params) {

      return this.fnpostInputParams(AppSettings.getBrandUrl, params);
   }


   fnDeleteBrand(params) {

      return this.fnpostInputParams(AppSettings.deleteBrandUrl, params);
   }

   fnCheckBrand(params) {

      return this.fnpostInputParams(AppSettings.checkBrandUrl, params);
   }


   //Cardtype 
   fnInsertCardtype(params) {

      return this.fnpostInputParams(AppSettings.insertCardtypeUrl, params);
   }

   fnSetCardtype(params) {

      return this.fnpostInputParams(AppSettings.setCardtypeUrl, params);
   }


   getCardtype(params) {

      return this.fnpostInputParams(AppSettings.getCardtypeUrl, params);
   }


   fnDeleteCardtype(params) {

      return this.fnpostInputParams(AppSettings.deleteCardtypeUrl, params);
   }

   fnCheckCardtype(params) {

      return this.fnpostInputParams(AppSettings.checkCardtypeUrl, params);
   }

   //Company 
   fnInsertCompany(params) {

      return this.fnpostInputParams(AppSettings.insertCompanyUrl, params);
   }

   fnSetCompany(params) {

      return this.fnpostInputParams(AppSettings.setCompanyUrl, params);
   }


   getCompany(params) {

      return this.fnpostInputParams(AppSettings.getCompanyUrl, params);
   }


   fnDeleteCompany(params) {

      return this.fnpostInputParams(AppSettings.deleteCompanyUrl, params);
   }

   fnCheckCompany(params) {

      return this.fnpostInputParams(AppSettings.checkCompanyUrl, params);
   }
   //Course 
   fnInsertCourse(params) {

      return this.fnpostInputParams(AppSettings.insertCourseUrl, params);
   }

   fnSetCourse(params) {

      return this.fnpostInputParams(AppSettings.setCourseUrl, params);
   }


   getCourse(params) {

      return this.fnpostInputParams(AppSettings.getCourseUrl, params);
   }


   fnDeleteCourse(params) {

      return this.fnpostInputParams(AppSettings.deleteCourseUrl, params);
   }

   fnCheckCourse(params) {

      return this.fnpostInputParams(AppSettings.checkCourseUrl, params);
   }

   //Cuisine 
   fnInsertCuisine(params) {

      return this.fnpostInputParams(AppSettings.insertCuisineUrl, params);
   }

   fnSetCuisine(params) {

      return this.fnpostInputParams(AppSettings.setCuisineUrl, params);
   }


   getCuisine(params) {

      return this.fnpostInputParams(AppSettings.getCuisineUrl, params);
   }


   fnDeleteCuisine(params) {

      return this.fnpostInputParams(AppSettings.deleteCuisineUrl, params);
   }

   fnCheckCuisine(params) {

      return this.fnpostInputParams(AppSettings.checkCuisineUrl, params);
   }


   //Department 
   fnInsertDepartment(params) {

      return this.fnpostInputParams(AppSettings.insertDepartmentUrl, params);
   }

   fnSetDepartment(params) {

      return this.fnpostInputParams(AppSettings.setDepartmentUrl, params);
   }


   getDepartment(params) {

      return this.fnpostInputParams(AppSettings.getDepartmentUrl, params);
   }


   fnDeleteDepartment(params) {

      return this.fnpostInputParams(AppSettings.deleteDepartmentUrl, params);
   }

   fnCheckDepartment(params) {

      return this.fnpostInputParams(AppSettings.checkDepartmentUrl, params);
   }
   //Dinetype 
   fnInsertDinetype(params) {

      return this.fnpostInputParams(AppSettings.insertDinetypeUrl, params);
   }

   fnSetDinetype(params) {

      return this.fnpostInputParams(AppSettings.setDinetypeUrl, params);
   }


   getDinetype(params) {

      return this.fnpostInputParams(AppSettings.getDinetypeUrl, params);
   }


   fnDeleteDinetype(params) {

      return this.fnpostInputParams(AppSettings.deleteDinetypeUrl, params);
   }

   fnCheckDinetype(params) {

      return this.fnpostInputParams(AppSettings.checkDinetypeUrl, params);
   }
   //Group 
   fnInsertGroup(params) {

      return this.fnpostInputParams(AppSettings.insertGroupUrl, params);
   }

   fnSetGroup(params) {

      return this.fnpostInputParams(AppSettings.setGroupUrl, params);
   }


   getGroup(params) {

      return this.fnpostInputParams(AppSettings.getGroupUrl, params);
   }


   fnDeleteGroup(params) {

      return this.fnpostInputParams(AppSettings.deleteGroupUrl, params);
   }

   fnCheckGroup(params) {

      return this.fnpostInputParams(AppSettings.checkGroupUrl, params);
   }
   //Subgroup 
   fnInsertSubgroup(params) {

      return this.fnpostInputParams(AppSettings.insertSubgroupUrl, params);
   }

   fnSetSubgroup(params) {

      return this.fnpostInputParams(AppSettings.setSubgroupUrl, params);
   }


   getSubgroup(params) {

      return this.fnpostInputParams(AppSettings.getSubgroupUrl, params);
   }


   fnDeleteSubgroup(params) {

      return this.fnpostInputParams(AppSettings.deleteSubgroupUrl, params);
   }

   fnCheckSubgroup(params) {

      return this.fnpostInputParams(AppSettings.checkSubgroupUrl, params);
   }

   //Modifier 
   fnInsertModifier(params) {

      return this.fnpostInputParams(AppSettings.insertModifierUrl, params);
   }

   fnSetModifier(params) {

      return this.fnpostInputParams(AppSettings.setModifierUrl, params);
   }


   getModifier(params) {

      return this.fnpostInputParams(AppSettings.getModifierUrl, params);
   }


   fnDeleteModifier(params) {

      return this.fnpostInputParams(AppSettings.deleteModifierUrl, params);
   }

   fnCheckModifier(params) {

      return this.fnpostInputParams(AppSettings.checkModifierUrl, params);
   }


   //Modifiertype 
   fnInsertModifiertype(params) {

      return this.fnpostInputParams(AppSettings.insertModifiertypeUrl, params);
   }

   fnSetModifiertype(params) {

      return this.fnpostInputParams(AppSettings.setModifiertypeUrl, params);
   }


   getModifiertype(params) {

      return this.fnpostInputParams(AppSettings.getModifiertypeUrl, params);
   }


   fnDeleteModifiertype(params) {

      return this.fnpostInputParams(AppSettings.deleteModifiertypeUrl, params);
   }

   fnCheckModifiertype(params) {

      return this.fnpostInputParams(AppSettings.checkModifiertypeUrl, params);
   }



   //Ordermode 
   fnInsertOrdermode(params) {

      return this.fnpostInputParams(AppSettings.insertOrdermodeUrl, params);
   }

   fnSetOrdermode(params) {

      return this.fnpostInputParams(AppSettings.setOrdermodeUrl, params);
   }


   getOrdermode(params) {

      return this.fnpostInputParams(AppSettings.getOrdermodeUrl, params);
   }


   fnDeleteOrdermode(params) {

      return this.fnpostInputParams(AppSettings.deleteOrdermodeUrl, params);
   }

   fnCheckOrdermode(params) {

      return this.fnpostInputParams(AppSettings.checkOrdermodeUrl, params);
   }

   //Party 
   fnInsertParty(params) {

      return this.fnpostInputParams(AppSettings.insertPartyUrl, params);
   }

   fnSetParty(params) {

      return this.fnpostInputParams(AppSettings.setPartyUrl, params);
   }


   getParty(params) {

      return this.fnpostInputParams(AppSettings.getPartyUrl, params);
   }
   getPartyFind(params) {

      return this.fnpostInputParams(AppSettings.getPartyFindUrl, params);
   }

   fnDeleteParty(params) {

      return this.fnpostInputParams(AppSettings.deletePartyUrl, params);
   }

   fnCheckParty(params) {

      return this.fnpostInputParams(AppSettings.checkPartyUrl, params);
   }

   //Paymentmode 
   fnInsertPaymentmode(params) {

      return this.fnpostInputParams(AppSettings.insertPaymentmodeUrl, params);
   }

   fnSetPaymentmode(params) {

      return this.fnpostInputParams(AppSettings.setPaymentmodeUrl, params);
   }


   getPaymentmode(params) {

      return this.fnpostInputParams(AppSettings.getPaymentmodeUrl, params);
   }

   getPaymentmodeTransaction(params) {

      return this.fnpostInputParams(AppSettings.getPaymentmodeTransactionUrl, params);
   }


   fnDeletePaymentmode(params) {

      return this.fnpostInputParams(AppSettings.deletePaymentmodeUrl, params);
   }

   fnCheckPaymentmode(params) {

      return this.fnpostInputParams(AppSettings.checkPaymentmodeUrl, params);
   }


   //Reason 
   fnInsertReason(params) {

      return this.fnpostInputParams(AppSettings.insertReasonUrl, params);
   }

   fnSetReason(params) {

      return this.fnpostInputParams(AppSettings.setReasonUrl, params);
   }


   getReason(params) {

      return this.fnpostInputParams(AppSettings.getReasonUrl, params);
   }


   fnDeleteReason(params) {

      return this.fnpostInputParams(AppSettings.deleteReasonUrl, params);
   }

   fnCheckReason(params) {

      return this.fnpostInputParams(AppSettings.checkReasonUrl, params);
   }


   //Shift 
   fnInsertShift(params) {

      return this.fnpostInputParams(AppSettings.insertShiftUrl, params);
   }

   fnSetShift(params) {

      return this.fnpostInputParams(AppSettings.setShiftUrl, params);
   }


   getShift(params) {

      return this.fnpostInputParams(AppSettings.getShiftUrl, params);
   }


   fnDeleteShift(params) {

      return this.fnpostInputParams(AppSettings.deleteShiftUrl, params);
   }

   fnCheckShift(params) {

      return this.fnpostInputParams(AppSettings.checkShiftUrl, params);
   }


   //Size 
   fnInsertSize(params) {

      return this.fnpostInputParams(AppSettings.insertSizeUrl, params);
   }

   fnSetSize(params) {

      return this.fnpostInputParams(AppSettings.setSizeUrl, params);
   }


   getSize(params) {

      return this.fnpostInputParams(AppSettings.getSizeUrl, params);
   }


   fnDeleteSize(params) {

      return this.fnpostInputParams(AppSettings.deleteSizeUrl, params);
   }

   fnCheckSize(params) {

      return this.fnpostInputParams(AppSettings.checkSizeUrl, params);
   }

   //Tax 
   fnInsertTax(params) {

      return this.fnpostInputParams(AppSettings.insertTaxUrl, params);
   }

   fnSetTax(params) {

      return this.fnpostInputParams(AppSettings.setTaxUrl, params);
   }


   getTax(params) {

      return this.fnpostInputParams(AppSettings.getTaxUrl, params);
   }


   fnDeleteTax(params) {

      return this.fnpostInputParams(AppSettings.deleteTaxUrl, params);
   }

   fnCheckTax(params) {

      return this.fnpostInputParams(AppSettings.checkTaxUrl, params);
   }

   //Uom 
   fnInsertUom(params) {

      return this.fnpostInputParams(AppSettings.insertUomUrl, params);
   }

   fnSetUom(params) {

      return this.fnpostInputParams(AppSettings.setUomUrl, params);
   }


   getUom(params) {

      return this.fnpostInputParams(AppSettings.getUomUrl, params);
   }


   fnDeleteUom(params) {

      return this.fnpostInputParams(AppSettings.deleteUomUrl, params);
   }

   fnCheckUom(params) {

      return this.fnpostInputParams(AppSettings.checkUomUrl, params);
   }
   //Station 
   fnInsertStation(params) {

      return this.fnpostInputParams(AppSettings.insertStationUrl, params);
   }

   fnSetStation(params) {

      return this.fnpostInputParams(AppSettings.setStationUrl, params);
   }


   getStation(params) {

      return this.fnpostInputParams(AppSettings.getStationUrl, params);
   }


   fnDeleteStation(params) {

      return this.fnpostInputParams(AppSettings.deleteStationUrl, params);
   }

   fnCheckStation(params) {

      return this.fnpostInputParams(AppSettings.checkStationUrl, params);
   }
   //TableSection 
   fnInsertTableSection(params) {

      return this.fnpostInputParams(AppSettings.insertTableSectionUrl, params);
   }

   fnSetTableSection(params) {

      return this.fnpostInputParams(AppSettings.setTableSectionUrl, params);
   }


   getTableSection(params) {

      return this.fnpostInputParams(AppSettings.getTableSectionUrl, params);
   }


   fnDeleteTableSection(params) {

      return this.fnpostInputParams(AppSettings.deleteTableSectionUrl, params);
   }

   fnCheckTableSection(params) {

      return this.fnpostInputParams(AppSettings.checkTableSectionUrl, params);
   }
   getTableByTableSection(params) {

      return this.fnpostInputParams(AppSettings.getTableByTableSectionUrl, params);
   }


   //Table 
   fnInsertTable(params) {

      return this.fnpostInputParams(AppSettings.insertTableUrl, params);
   }

   fnSetTable(params) {

      return this.fnpostInputParams(AppSettings.setTableUrl, params);
   }


   getTable(params) {

      return this.fnpostInputParams(AppSettings.getTableUrl, params);
   }


   fnDeleteTable(params) {

      return this.fnpostInputParams(AppSettings.deleteTableUrl, params);
   }

   fnCheckTable(params) {

      return this.fnpostInputParams(AppSettings.checkTableUrl, params);
   }



   //Foodsymbol 
   fnInsertFoodsymbol(params) {

      return this.fnpostInputParams(AppSettings.insertFoodsymbolUrl, params);
   }

   fnSetFoodsymbol(params) {

      return this.fnpostInputParams(AppSettings.setFoodsymbolUrl, params);
   }


   getFoodsymbol(params) {

      return this.fnpostInputParams(AppSettings.getFoodsymbolUrl, params);
   }


   fnDeleteFoodsymbol(params) {

      return this.fnpostInputParams(AppSettings.deleteFoodsymbolUrl, params);
   }

   fnCheckFoodsymbol(params) {

      return this.fnpostInputParams(AppSettings.checkFoodsymbolUrl, params);
   }



   //Locality 
   fnInsertLocality(params) {

      return this.fnpostInputParams(AppSettings.insertLocalityUrl, params);
   }

   fnSetLocality(params) {

      return this.fnpostInputParams(AppSettings.setLocalityUrl, params);
   }


   getLocality(params) {

      return this.fnpostInputParams(AppSettings.getLocalityUrl, params);
   }


   fnDeleteLocality(params) {

      return this.fnpostInputParams(AppSettings.deleteLocalityUrl, params);
   }

   fnCheckLocality(params) {

      return this.fnpostInputParams(AppSettings.checkLocalityUrl, params);
   }


   //Settings 

   getSettingsCompany(params) {

      return this.fnpostInputParams(AppSettings.getSettingsCompanyUrl, params);
   }
   fnsetSettingsCompany(params) {

      return this.fnpostInputParams(AppSettings.setSettingsCompanyUrl, params);
   }

   //Shiftactivity 

   fnCheckShiftactivity(params) {

      return this.fnpostInputParams(AppSettings.checkShiftactivityUrl, params);
   }
   fnInsertShiftactivity(params) {

      return this.fnpostInputParams(AppSettings.insertShiftactivityUrl, params);
   }

   //Currency 
   fnInsertCurrency(params) {

      return this.fnpostInputParams(AppSettings.insertCurrencyUrl, params);
   }

   fnSetCurrency(params) {

      return this.fnpostInputParams(AppSettings.setCurrencyUrl, params);
   }


   getCurrencyListview(params) {

      return this.fnpostInputParams(AppSettings.getCurrencyListviewUrl, params);
   }
   getCurrency(params) {

      return this.fnpostInputParams(AppSettings.getCurrencyUrl, params);
   }


   fnDeleteCurrency(params) {

      return this.fnpostInputParams(AppSettings.deleteCurrencyUrl, params);
   }

   fnCheckCurrency(params) {

      return this.fnpostInputParams(AppSettings.checkCurrencyUrl, params);
   }








   //Sales
   getDashDinetype(params) {

      return this.fnpostInputParams(AppSettings.getDashDinetypeUrl, params);
   }
   getDashTablesection(params) {

      return this.fnpostInputParams(AppSettings.getDashTablesectionUrl, params);
   }
   getDashTable(params) {

      return this.fnpostInputParams(AppSettings.getDashTableUrl, params);
   }
   getDashGroup(params) {

      return this.fnpostInputParams(AppSettings.getDashGroupUrl, params);
   }

   getDashProductListview(params) {

      return this.fnpostInputParams(AppSettings.getDashProductListviewUrl, params);
   }

   getDashProductDetails(params) {

      return this.fnpostInputParams(AppSettings.getDashProductDetailsUrl, params);
   }

   insertSales(params) {

      return this.fnpostInputParams(AppSettings.insertSalesUrl, params);
   }

   getSalesBySalesDetails(params) {

      return this.fnpostInputParams(AppSettings.getSalesBySalesDetailsUrl, params);
   }
   getDashPaymentmode(params) {

      return this.fnpostInputParams(AppSettings.getDashPaymentmodeUrl, params);
   }

   getDashCashDenaminaion(params) {

      return this.fnpostInputParams(AppSettings.getDashCashDenaminaionUrl, params);
   }


   getChargesBySales(params) {

      return this.fnpostInputParams(AppSettings.getChargesBySalesUrl, params);
   }

   getPrintKotBySales(params) {

      return this.fnpostInputParams(AppSettings.getPrintKotBySalesUrl, params);
   }

   getPrintReceiptBySales(params) {

      return this.fnpostInputParams(AppSettings.getSalesByPrintUrl, params);
   }

   getSalesListClosedOpen(params) {

      return this.fnpostInputParams(AppSettings.getSalesListClosedOpenUrl, params);
   }



   //Income 
   fnInsertIncome(params) {

      return this.fnpostInputParams(AppSettings.insertIncomeUrl, params);
   }

   fnSetIncome(params) {

      return this.fnpostInputParams(AppSettings.setIncomeUrl, params);
   }


   getIncome(params) {

      return this.fnpostInputParams(AppSettings.getIncomeUrl, params);
   }
   getIncomeListview(params) {

      return this.fnpostInputParams(AppSettings.getIncomeListviewUrl, params);
   }


   fnDeleteIncome(params) {

      return this.fnpostInputParams(AppSettings.deleteIncomeUrl, params);
   }

   fnCheckIncome(params) {

      return this.fnpostInputParams(AppSettings.checkIncomeUrl, params);
   }
   //Charges 
   fnInsertCharges(params) {

      return this.fnpostInputParams(AppSettings.insertChargesUrl, params);
   }

   fnSetCharges(params) {

      return this.fnpostInputParams(AppSettings.setChargesUrl, params);
   }


   getCharges(params) {

      return this.fnpostInputParams(AppSettings.getChargesUrl, params);
   }


   fnDeleteCharges(params) {

      return this.fnpostInputParams(AppSettings.deleteChargesUrl, params);
   }

   fnCheckCharges(params) {

      return this.fnpostInputParams(AppSettings.checkChargesUrl, params);
   }


   //Expense 
   fnInsertExpense(params) {

      return this.fnpostInputParams(AppSettings.insertExpenseUrl, params);
   }

   fnSetExpense(params) {

      return this.fnpostInputParams(AppSettings.setExpenseUrl, params);
   }


   getExpense(params) {

      return this.fnpostInputParams(AppSettings.getExpenseUrl, params);
   }
   getExpenseListview(params) {

      return this.fnpostInputParams(AppSettings.getExpenseListviewUrl, params);
   }


   fnDeleteExpense(params) {

      return this.fnpostInputParams(AppSettings.deleteExpenseUrl, params);
   }

   fnCheckExpense(params) {

      return this.fnpostInputParams(AppSettings.checkExpenseUrl, params);
   }
   //Voucher 
   fnInsertVoucher(params) {

      return this.fnpostInputParams(AppSettings.insertVoucherUrl, params);
   }

   fnSetVoucher(params) {

      return this.fnpostInputParams(AppSettings.setVoucherUrl, params);
   }


   getVoucher(params) {

      return this.fnpostInputParams(AppSettings.getVoucherUrl, params);
   }


   fnDeleteVoucher(params) {

      return this.fnpostInputParams(AppSettings.deleteVoucherUrl, params);
   }

   fnCheckVoucher(params) {

      return this.fnpostInputParams(AppSettings.checkVoucherUrl, params);
   }
   //Common
   fnGetIpAddress() {
      this.http.get('https://jsonip.com')
         .subscribe(data => {
            this.ipAddress = data.json()
         })
   }

   fnInsertActivity(data) {

      var dept_para = {
         logtype: data.logtype,
         logat: data.logat,
         refnum: data.refnum,
         logdescr: data.logdescr,
         logby: data.logby,
         ipaddress: this.ipAddress.ip,
         devicename: this.deviceInfo.browser + " " + this.deviceInfo.os,
      };


      return this.fnpostInputParams(AppSettings.insertActivitylogUrl, dept_para);
   }

   //Report 
   getOpenbillReport(params) {

      return this.fnpostInputParams(AppSettings.getopenbillreportUrl, params);
   }
   getActivitylogReport(params) {

      return this.fnpostInputParams(AppSettings.getActivitylogReportUrl, params);
   }

   getUserappform(params) {

      return this.fnpostInputParams(AppSettings.getUserappformUrl, params);
   }
   getSalesReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesReportUrl, params);
   }
   getStockReport(params) {

      return this.fnpostInputParams(AppSettings.getStockReportUrl, params);
   }
   getStockRangeReport(params) {

      return this.fnpostInputParams(AppSettings.getStockRangeReportUrl, params);
   }
   getPurchaseReport(params) {

      return this.fnpostInputParams(AppSettings.getPurchaseReportUrl, params);
   }
   getAdjReport(params) {

      return this.fnpostInputParams(AppSettings.getAdjReportUrl, params);
   }
   getProductCancelReport(params) {

      return this.fnpostInputParams(AppSettings.getProductCancelReportUrl, params);
   }
   getBillCancelReport(params) {

      return this.fnpostInputParams(AppSettings.getBillCancelReportUrl, params);
   }
   getBillSummaryReport(params) {

      return this.fnpostInputParams(AppSettings.getBillSummaryReportUrl, params);
   }
   getTaxSummaryReport(params) {

      return this.fnpostInputParams(AppSettings.getTaxSummaryReportUrl, params);
   }
   getSalesXReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesxReportUrl, params);
   }
   getIncomeReport(params) {

      return this.fnpostInputParams(AppSettings.getIncomeReportUrl, params);
   }
   getExpenseReport(params) {

      return this.fnpostInputParams(AppSettings.getExpenseReportUrl, params);
   }
   getExpenseDetailsReport(params) {

      return this.fnpostInputParams(AppSettings.getExpenseDetailsReportUrl, params);
   }

   getHourlyitemsalesReport(params) {

      return this.fnpostInputParams(AppSettings.getHourlyitemsalesReportUrl, params);
   }
   getPaymentwiseOrderReport(params) {

      return this.fnpostInputParams(AppSettings.getPaymentwiseOrderReportUrl, params);
   }
   getStationwiseReport(params) {

      return this.fnpostInputParams(AppSettings.getStationwiseReportUrl, params);
   }
   getSalesGroupReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesGroupReportUrl, params);
   }
   getSalesProductReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesProductReportUrl, params);
   }

   getSalesDineTypeReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesDineTypeReportUrl, params);
   }

   getSalesDailyReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesDailyReportUrl, params);
   }
   getSalesDailyShiftReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesDailyShiftReportUrl, params);
   }
      getSalesDailyPaymentReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesDailyPaymentReportUrl, params);
   }
   getSalesOutletWiseReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesOutletWiseReportUrl, params);
   }

   getSalesOrderModeReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesOrderModeReportUrl, params);
   }
   getSalesDiscountReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesDiscountReportUrl, params);
   }
   getSalesPaymentModeReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesPaymentModeReportUrl, params);
   }
   getSalesTableSectionReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesTableSectionReportUrl, params);
   }
   getSalesTableReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesTableReportUrl, params);
   }
   getSalesCustomerReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesCustomerReportUrl, params);
   }

   getSalesCustomerStatementReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesCustomerStatementReportUrl, params);
   }
   getSalesBillCancelSummaryReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesBillCancelSummaryReportUrl, params);
   }
   getSalesLocalityReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesLocalityReportUrl, params);
   }
   getSalesBillPaymentReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesBillPaymentReportUrl, params);
   }
   getSalesComplimentoryReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesComplimentoryReportUrl, params);
   }
   getSalesFastMovingReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesFastMovingReportUrl, params);
   }
   getSalesVariationReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesVariationReportUrl, params);
   }
   getSalesCashierReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesCashierReportUrl, params);
   }

   getSalesWaiterReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesWaiterReportUrl, params);
   }

   getSalesDetailsByQuickView(params) {

      return this.fnpostInputParams(AppSettings.getSalesDetailsByQuickViewUrl, params);
   }

   getSalesActivityLogReport(params) {

      return this.fnpostInputParams(AppSettings.getSalesActivityLogReportUrl, params);
   }

   getAccountReport(params) {

      return this.fnpostInputParams(AppSettings.getAccountReportUrl, params);
   }

   getProfitLossReport(params) {

      return this.fnpostInputParams(AppSettings.getProfitLossReportUrl, params);
   }


   getTrailBalanceReport(params) {

      return this.fnpostInputParams(AppSettings.getTrailBalanceReportUrl, params);
   }


   getBalanceSheetReport(params) {

      return this.fnpostInputParams(AppSettings.getBalanceSheetReportUrl, params);
   }

   getPayableReport(params) {

      return this.fnpostInputParams(AppSettings.getPayableReportUrl, params);
   }


   getReceivableReport(params) {

      return this.fnpostInputParams(AppSettings.getReceivableReportUrl, params);
   }


   getOutletShiftCloseReport(params) {

      return this.fnpostInputParams(AppSettings.getOutletShiftCloseReportUrl, params);
   }

   getOutletNewCustomerReport(params) {

      return this.fnpostInputParams(AppSettings.getOutletNewCustomerReportUrl, params);
   }

   getOutletCustomerFootFallReport(params) {

      return this.fnpostInputParams(AppSettings.getOutletCustomerFootFallReportUrl, params);
   }

   //ProductQuickMenu 
   fnInsertProductQuickMenu(params) {

      return this.fnpostInputParams(AppSettings.insertProductQuickMenuUrl, params);
   }

   getProductQuickMenu(params) {

      return this.fnpostInputParams(AppSettings.getProductQuickMenuUrl, params);
   }


   fnDeleteProductQuickMenu(params) {

      return this.fnpostInputParams(AppSettings.deleteProductQuickMenuUrl, params);
   }

   fnCheckProductQuickMenu(params) {

      return this.fnpostInputParams(AppSettings.checkProductQuickMenuUrl, params);
   }

   //ShiftCloseEmail 
   fnInsertShiftCloseEmail(params) {

      return this.fnpostInputParams(AppSettings.insertShiftCloseEmailUrl, params);
   }

   getShiftCloseEmail(params) {

      return this.fnpostInputParams(AppSettings.getShiftCloseEmailUrl, params);
   }


   fnDeleteShiftCloseEmail(params) {

      return this.fnpostInputParams(AppSettings.deleteShiftCloseEmailUrl, params);
   }

   fnCheckShiftCloseEmail(params) {

      return this.fnpostInputParams(AppSettings.checkShiftCloseEmailUrl, params);
   }

   // Employee
   fnInsertEmployee(params) {

      return this.fnpostInputParams(AppSettings.insertEmployeeUrl, params);
   }

   fnSetEmployee(params) {

      return this.fnpostInputParams(AppSettings.setEmployeeUrl, params);
   }


   getEmployee(params) {

      return this.fnpostInputParams(AppSettings.getEmployeeUrl, params);
   }


   fnDeleteEmployee(params) {

      return this.fnpostInputParams(AppSettings.deleteEmployeeUrl, params);
   }

   fnCheckEmployee(params) {

      return this.fnpostInputParams(AppSettings.checkEmployeeUrl, params);
   }


   // Purchase
   fnInsertPurchase(params) {

      return this.fnpostInputParams(AppSettings.insertPurchaseUrl, params);
   }

   fnSetPurchase(params) {

      return this.fnpostInputParams(AppSettings.setPurchaseUrl, params);
   }


   getPurchaseByListview(params) {

      return this.fnpostInputParams(AppSettings.getPurchaseByListviewUrl, params);
   }


   getPurchase(params) {

      return this.fnpostInputParams(AppSettings.getPurchaseByPurchaseidUrl, params);
   }

   fnDeletePurchase(params) {

      return this.fnpostInputParams(AppSettings.deletePurchaseUrl, params);
   }

   // Lpo
   fnInsertLpo(params) {

      return this.fnpostInputParams(AppSettings.insertLpoUrl, params);
   }

   fnSetLpo(params) {

      return this.fnpostInputParams(AppSettings.setLpoUrl, params);
   }


   getLpoByListview(params) {

      return this.fnpostInputParams(AppSettings.getLpoByListviewUrl, params);
   }


   getLpo(params) {

      return this.fnpostInputParams(AppSettings.getLpoByLpoidUrl, params);
   }

   fnDeleteLpo(params) {

      return this.fnpostInputParams(AppSettings.deleteLpoUrl, params);
   }

   //Adjtype 
   fnInsertAdjtype(params) {

      return this.fnpostInputParams(AppSettings.insertAdjtypeUrl, params);
   }

   fnSetAdjtype(params) {

      return this.fnpostInputParams(AppSettings.setAdjtypeUrl, params);
   }


   getAdjtype(params) {

      return this.fnpostInputParams(AppSettings.getAdjtypeUrl, params);
   }


   fnDeleteAdjtype(params) {

      return this.fnpostInputParams(AppSettings.deleteAdjtypeUrl, params);
   }

   fnCheckAdjtype(params) {

      return this.fnpostInputParams(AppSettings.checkAdjtypeUrl, params);
   }

   // Adj
   fnInsertAdj(params) {

      return this.fnpostInputParams(AppSettings.insertAdjUrl, params);
   }

   fnSetAdj(params) {

      return this.fnpostInputParams(AppSettings.setAdjUrl, params);
   }


   getAdjByListview(params) {

      return this.fnpostInputParams(AppSettings.getAdjByListviewUrl, params);
   }


   getAdj(params) {

      return this.fnpostInputParams(AppSettings.getAdjByAdjidUrl, params);
   }

   fnDeleteAdj(params) {

      return this.fnpostInputParams(AppSettings.deleteAdjUrl, params);
   }


   // Physicalstock
   fnInsertPhysicalstock(params) {

      return this.fnpostInputParams(AppSettings.insertPhysicalstockUrl, params);
   }

   fnSetPhysicalstock(params) {

      return this.fnpostInputParams(AppSettings.setPhysicalstockUrl, params);
   }


   getPhysicalstockByListview(params) {

      return this.fnpostInputParams(AppSettings.getPhysicalstockByListviewUrl, params);
   }


   getPhysicalstock(params) {

      return this.fnpostInputParams(AppSettings.getPhysicalstockByPhysicalstockidUrl, params);
   }

   fnDeletePhysicalstock(params) {

      return this.fnpostInputParams(AppSettings.deletePhysicalstockUrl, params);
   }

   getRawmaterialPhysicalstock(params) {

      return this.fnpostInputParams(AppSettings.getRawmaterialPhysicalstockUrl, params);
   }



 // Xfer
 fnInsertXfer(params) {

   return this.fnpostInputParams(AppSettings.insertXferUrl, params);
}

fnSetXfer(params) {

   return this.fnpostInputParams(AppSettings.setXferUrl, params);
}


getXferByListview(params) {

   return this.fnpostInputParams(AppSettings.getXferByListviewUrl, params);
}


getXfer(params) {

   return this.fnpostInputParams(AppSettings.getXferByXferidUrl, params);
}

fnDeleteXfer(params) {

   return this.fnpostInputParams(AppSettings.deleteXferUrl, params);
}
getCompanyXfer(params) {

   return this.fnpostInputParams(AppSettings.getCompanyXferUrl, params);
}

   // Recipe
   fnInsertRecipe(params) {

      return this.fnpostInputParams(AppSettings.insertRecipeUrl, params);
   }

   fnSetRecipe(params) {

      return this.fnpostInputParams(AppSettings.setRecipeUrl, params);
   }


   getRecipeByListview(params) {

      return this.fnpostInputParams(AppSettings.getRecipeByListviewUrl, params);
   }


   getRecipe(params) {

      return this.fnpostInputParams(AppSettings.getRecipeByProductidUrl, params);
   }

   fnDeleteRecipe(params) {

      return this.fnpostInputParams(AppSettings.deleteRecipeUrl, params);
   }

   //Expensetype 
   fnInsertExpensetype(params) {

      return this.fnpostInputParams(AppSettings.insertExpensetypeUrl, params);
   }

   fnSetExpensetype(params) {

      return this.fnpostInputParams(AppSettings.setExpensetypeUrl, params);
   }


   getExpensetype(params) {

      return this.fnpostInputParams(AppSettings.getExpensetypeUrl, params);
   }


   fnDeleteExpensetype(params) {

      return this.fnpostInputParams(AppSettings.deleteExpensetypeUrl, params);
   }

   fnCheckExpensetype(params) {

      return this.fnpostInputParams(AppSettings.checkExpensetypeUrl, params);
   }

   //Incometype 
   fnInsertIncometype(params) {

      return this.fnpostInputParams(AppSettings.insertIncometypeUrl, params);
   }

   fnSetIncometype(params) {

      return this.fnpostInputParams(AppSettings.setIncometypeUrl, params);
   }


   getIncometype(params) {

      return this.fnpostInputParams(AppSettings.getIncometypeUrl, params);
   }


   fnDeleteIncometype(params) {

      return this.fnpostInputParams(AppSettings.deleteIncometypeUrl, params);
   }

   fnCheckIncometype(params) {

      return this.fnpostInputParams(AppSettings.checkIncometypeUrl, params);
   }


   //Pricetype 
   fnInsertPricetype(params) {

      return this.fnpostInputParams(AppSettings.insertPricetypeUrl, params);
   }

   fnSetPricetype(params) {

      return this.fnpostInputParams(AppSettings.setPricetypeUrl, params);
   }


   getPricetype(params) {

      return this.fnpostInputParams(AppSettings.getPricetypeUrl, params);
   }


   fnDeletePricetype(params) {

      return this.fnpostInputParams(AppSettings.deletePricetypeUrl, params);
   }

   fnCheckPricetype(params) {

      return this.fnpostInputParams(AppSettings.checkPricetypeUrl, params);
   }
   //Kitchennotes 
   fnInsertKitchennotes(params) {

      return this.fnpostInputParams(AppSettings.insertKitchennotesUrl, params);
   }

   fnSetKitchennotes(params) {

      return this.fnpostInputParams(AppSettings.setKitchennotesUrl, params);
   }


   getKitchennotes(params) {

      return this.fnpostInputParams(AppSettings.getKitchennotesUrl, params);
   }


   fnDeleteKitchennotes(params) {

      return this.fnpostInputParams(AppSettings.deleteKitchennotesUrl, params);
   }

   fnCheckKitchennotes(params) {

      return this.fnpostInputParams(AppSettings.checkKitchennotesUrl, params);
   }

   //Itemcategory 
   fnInsertItemcategory(params) {

      return this.fnpostInputParams(AppSettings.insertItemcategoryUrl, params);
   }

   fnSetItemcategory(params) {

      return this.fnpostInputParams(AppSettings.setItemcategoryUrl, params);
   }


   getItemcategory(params) {

      return this.fnpostInputParams(AppSettings.getItemcategoryUrl, params);
   }


   fnDeleteItemcategory(params) {

      return this.fnpostInputParams(AppSettings.deleteItemcategoryUrl, params);
   }

   fnCheckItemcategory(params) {

      return this.fnpostInputParams(AppSettings.checkItemcategoryUrl, params);
   }


   //Rawmaterial 
   fnInsertRawmaterial(params) {

      return this.fnpostInputParams(AppSettings.insertRawmaterialUrl, params);
   }

   fnSetRawmaterial(params) {

      return this.fnpostInputParams(AppSettings.setRawmaterialUrl, params);
   }


   getRawmaterial(params) {

      return this.fnpostInputParams(AppSettings.getRawmaterialUrl, params);
   }


   fnDeleteRawmaterial(params) {

      return this.fnpostInputParams(AppSettings.deleteRawmaterialUrl, params);
   }

   fnCheckRawmaterial(params) {

      return this.fnpostInputParams(AppSettings.checkRawmaterialUrl, params);
   }



   // PurchaseReturn
   fnInsertPurchaseReturn(params) {

      return this.fnpostInputParams(AppSettings.insertPurchaseReturnUrl, params);
   }

   fnSetPurchaseReturn(params) {

      return this.fnpostInputParams(AppSettings.setPurchaseReturnUrl, params);
   }


   getPurchaseReturnByListview(params) {

      return this.fnpostInputParams(AppSettings.getPurchaseReturnByListviewUrl, params);
   }


   getPurchaseReturn(params) {

      return this.fnpostInputParams(AppSettings.getPurchaseReturnByPurchaseReturnidUrl, params);
   }

   fnDeletePurchaseReturn(params) {

      return this.fnpostInputParams(AppSettings.deletePurchaseReturnUrl, params);
   }





   getSupportListview(params) {

      return this.fnpostInputParams(AppSettings.getSupportListviewUrl, params);
   }


   fnsetSupport(params) {

      return this.fnpostInputParams(AppSettings.setSupportUrl, params);
   }




   //Devices 


   fnSetDevices(params) {

      return this.fnpostInputParams(AppSettings.setDevicesUrl, params);
   }


   getDevices(params) {

      return this.fnpostInputParams(AppSettings.getDevicesUrl, params);
   }







   fnGetDashboardAdmin(params) {

      return this.fnpostInputParams(AppSettings.getDashboardAdminUrl, params);
   }




   fnGetDashboardOrganizationAdmin(params) {

      return this.fnpostInputParams(AppSettings.getDashboardOrganizationAdminUrl, params);
   }


   //Accounttype
   fnInsertAccounttype(params) {

      return this.fnpostInputParams(AppSettings.insertAccounttypeUrl, params);
   }

   fnSetAccounttype(params) {

      return this.fnpostInputParams(AppSettings.setAccounttypeUrl, params);
   }


   getAccounttype(params) {

      return this.fnpostInputParams(AppSettings.getAccounttypeUrl, params);
   }

   getAccountgroup(params) {

      return this.fnpostInputParams(AppSettings.getAccountgroupUrl, params);
   }

   fnDeleteAccounttype(params) {

      return this.fnpostInputParams(AppSettings.deleteAccounttypeUrl, params);
   }

   fnCheckAccounttype(params) {

      return this.fnpostInputParams(AppSettings.checkAccounttypeUrl, params);
   }

   //Account
   fnInsertAccount(params) {

      return this.fnpostInputParams(AppSettings.insertAccountUrl, params);
   }

   fnSetAccount(params) {

      return this.fnpostInputParams(AppSettings.setAccountUrl, params);
   }


   getAccount(params) {

      return this.fnpostInputParams(AppSettings.getAccountUrl, params);
   }


   getAccountByPaymenttype(params) {

      return this.fnpostInputParams(AppSettings.getAccountByPaymenttypeUrl, params);
   }


   fnDeleteAccount(params) {

      return this.fnpostInputParams(AppSettings.deleteAccountUrl, params);
   }

   fnCheckAccount(params) {

      return this.fnpostInputParams(AppSettings.checkAccountUrl, params);
   }

   //SubledgerType
   fnInsertSubledgerType(params) {

      return this.fnpostInputParams(AppSettings.insertSubledgerTypeUrl, params);
   }

   fnSetSubledgerType(params) {

      return this.fnpostInputParams(AppSettings.setSubledgerTypeUrl, params);
   }


   getSubledgerType(params) {

      return this.fnpostInputParams(AppSettings.getSubledgerTypeUrl, params);
   }

   getSubledgerTypeListview(params) {

      return this.fnpostInputParams(AppSettings.getSubledgerTypeListviewUrl, params);
   }


   fnDeleteSubledgerType(params) {

      return this.fnpostInputParams(AppSettings.deleteSubledgerTypeUrl, params);
   }

   fnCheckSubledgerType(params) {

      return this.fnpostInputParams(AppSettings.checkSubledgerTypeUrl, params);
   }




   //Subledger
   fnInsertSubledger(params) {

      return this.fnpostInputParams(AppSettings.insertSubledgerUrl, params);
   }

   fnSetSubledger(params) {

      return this.fnpostInputParams(AppSettings.setSubledgerUrl, params);
   }


   getSubledger(params) {

      return this.fnpostInputParams(AppSettings.getSubledgerUrl, params);
   }


   fnDeleteSubledger(params) {

      return this.fnpostInputParams(AppSettings.deleteSubledgerUrl, params);
   }

   fnCheckSubledger(params) {

      return this.fnpostInputParams(AppSettings.checkSubledgerUrl, params);
   }


   //CostCenter
   fnInsertCostCenter(params) {

      return this.fnpostInputParams(AppSettings.insertCostCenterUrl, params);
   }

   fnSetCostCenter(params) {

      return this.fnpostInputParams(AppSettings.setCostCenterUrl, params);
   }


   getCostCenter(params) {

      return this.fnpostInputParams(AppSettings.getCostCenterUrl, params);
   }


   fnDeleteCostCenter(params) {

      return this.fnpostInputParams(AppSettings.deleteCostCenterUrl, params);
   }

   fnCheckCostCenter(params) {

      return this.fnpostInputParams(AppSettings.checkCostCenterUrl, params);
   }

   // Jv
   fnInsertJv(params) {

      return this.fnpostInputParams(AppSettings.insertJvUrl, params);
   }

   fnSetJv(params) {

      return this.fnpostInputParams(AppSettings.setJvUrl, params);
   }


   getJvByListview(params) {

      return this.fnpostInputParams(AppSettings.getJvByListviewUrl, params);
   }


   getJvByJvid(params) {

      return this.fnpostInputParams(AppSettings.getJvByJvidUrl, params);
   }

   fnDeleteJv(params) {

      return this.fnpostInputParams(AppSettings.deleteJvUrl, params);
   }


   // Defaultledger
   getDefaultAccount(params) {

      return this.fnpostInputParams(AppSettings.getDefaultAccountUrl, params);
   }
   fnSetDefaultAccount(params) {

      return this.fnpostInputParams(AppSettings.setDefaultAccountUrl, params);
   }
   getDefaultAdjustment(params) {

      return this.fnpostInputParams(AppSettings.getDefaultAdjustmentUrl, params);
   }

   
 //Postings 
 fnInsertPostings(params) {
   return this.fnpostInputParams(AppSettings.insertPostingUrl, params);
}

fnInsertUnPostings(params) {
   return this.fnpostInputParams(AppSettings.insertUnPostingUrl, params);
}
 // Payment
 fnInsertPayment(params) {

   return this.fnpostInputParams(AppSettings.insertPaymentUrl, params);
}

fnSetPayment(params) {

   return this.fnpostInputParams(AppSettings.setPaymentUrl, params);
}


getPaymentByListview(params) {

   return this.fnpostInputParams(AppSettings.getPaymentByListviewUrl, params);
}


getPayment(params) {

   return this.fnpostInputParams(AppSettings.getPaymentUrl, params);
}

fnDeletePayment(params) {

   return this.fnpostInputParams(AppSettings.deletePaymentUrl, params);
}
getPaymentPayable(params) {

   return this.fnpostInputParams(AppSettings.getPaymentPayableUrl, params);
}

   // Transfer
   fnInsertTransfer(params) {

      return this.fnpostInputParams(AppSettings.insertTransferUrl, params);
   }

   fnSetTransfer(params) {

      return this.fnpostInputParams(AppSettings.setTransferUrl, params);
   }


   getTransferByListview(params) {

      return this.fnpostInputParams(AppSettings.getTransferByListviewUrl, params);
   }


   getTransfer(params) {

      return this.fnpostInputParams(AppSettings.getTransferByTransferidUrl, params);
   }

   fnDeleteTransfer(params) {

      return this.fnpostInputParams(AppSettings.deleteAdjUrl, params);
   }


























}


